class SectionLinks extends HTMLElement {
  connectedCallback() {
    const template = this.querySelector('template');
    if (!template) return;

    const sections = document.querySelectorAll('[data-link-to-section]');

    if (!sections.length) {
      this.hidden = true;
      return;
    }

    sections.forEach((section, index) => {
      if (!section.id) {
        section.id = `section-link-target-${index}`;
      }

      const clone = template.content.cloneNode(true);
      const link = clone.querySelector('a');
      if (!link) return;

      link.href = `#${section.id}`;

      link.addEventListener('click', (event) => {
        event.preventDefault();
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      const label = clone.querySelector('.btn__text');
      if (label) {
        label.textContent = section.dataset.linkToSection;
      }

      this.appendChild(clone);
    });
  }
}

customElements.define('section-links', SectionLinks);
